import { Injectable } from "@angular/core";
import { BaseService } from "../../../@core/services/base.service";
import { PanelConfig } from "./collapsible-panel.component";

@Injectable({
    providedIn: 'root'
})
export class CollapsiblePanelService extends BaseService {
    panels: PanelConfig[] = [];
    isAllPanelsCollapsed: boolean = false;
    activePanelIndex: number = 0;
    isTransitioning: boolean = false;

    togglePanel(index: number): void {
        // Don't allow new toggles during transition
        if (this.isTransitioning) {
            return;
        }

        // If clicking the same panel, toggle its collapsed state
        if (this.activePanelIndex === index) {
            this.panels[index].isCollapsed = !this.panels[index].isCollapsed;
        } else {
            // Set transitioning flag
            this.isTransitioning = true;

            // Update panel states
            this.panels = this.panels.map((curr, i) => {
                curr.isCollapsed = i === index ? false : true;
                return curr;
            });

            this.activePanelIndex = index;

            // Clear transitioning flag after animation completes
            setTimeout(() => {
                this.isTransitioning = false;
            }, 400); // Should match the CSS transition duration
        }

        this.isAllPanelsCollapsed = this.panels.every(curr => curr.isCollapsed);
    }
}